// ====================================================
// Scalars
// ====================================================
export var TeamState;
(function (TeamState) {
    TeamState["Ok"] = "OK";
    TeamState["Hidden"] = "HIDDEN";
    TeamState["Protected"] = "PROTECTED";
})(TeamState || (TeamState = {}));
export var TenantActivationStatus;
(function (TenantActivationStatus) {
    TenantActivationStatus["Activated"] = "ACTIVATED";
    TenantActivationStatus["Onhold"] = "ONHOLD";
    TenantActivationStatus["Deactivated"] = "DEACTIVATED";
})(TenantActivationStatus || (TenantActivationStatus = {}));
export var UpsellRegion;
(function (UpsellRegion) {
    UpsellRegion["Gbr"] = "GBR";
    UpsellRegion["Ire"] = "IRE";
    UpsellRegion["Aus"] = "AUS";
    UpsellRegion["Fra"] = "FRA";
})(UpsellRegion || (UpsellRegion = {}));
export var HomePageWidgetTypes;
(function (HomePageWidgetTypes) {
    HomePageWidgetTypes["Image"] = "image";
    HomePageWidgetTypes["ImageWithText"] = "imageWithText";
    HomePageWidgetTypes["Video"] = "video";
})(HomePageWidgetTypes || (HomePageWidgetTypes = {}));
export var RedemptionEvents;
(function (RedemptionEvents) {
    RedemptionEvents["UsersDateOfBirth"] = "USERS_DATE_OF_BIRTH";
})(RedemptionEvents || (RedemptionEvents = {}));
export var DealStatus;
(function (DealStatus) {
    DealStatus["All"] = "ALL";
    DealStatus["On"] = "ON";
    DealStatus["Off"] = "OFF";
    DealStatus["Hidden"] = "HIDDEN";
    DealStatus["Test"] = "TEST";
    DealStatus["Archived"] = "ARCHIVED";
})(DealStatus || (DealStatus = {}));
export var PaymentCurrencyType;
(function (PaymentCurrencyType) {
    PaymentCurrencyType["Gbp"] = "GBP";
    PaymentCurrencyType["Eur"] = "EUR";
    PaymentCurrencyType["Aud"] = "AUD";
})(PaymentCurrencyType || (PaymentCurrencyType = {}));
export var RedemptionStatus;
(function (RedemptionStatus) {
    RedemptionStatus["Started"] = "STARTED";
    RedemptionStatus["Complete"] = "COMPLETE";
})(RedemptionStatus || (RedemptionStatus = {}));
export var DealSagaStep;
(function (DealSagaStep) {
    DealSagaStep["Error"] = "ERROR";
    DealSagaStep["Started"] = "STARTED";
    DealSagaStep["Order"] = "ORDER";
    DealSagaStep["Update"] = "UPDATE";
    DealSagaStep["Pay"] = "PAY";
    DealSagaStep["Complete"] = "COMPLETE";
    DealSagaStep["Aborted"] = "ABORTED";
    DealSagaStep["Refund"] = "REFUND";
})(DealSagaStep || (DealSagaStep = {}));
export var PaymentOrderStatus;
(function (PaymentOrderStatus) {
    PaymentOrderStatus["Pending"] = "PENDING";
    PaymentOrderStatus["Completed"] = "COMPLETED";
    PaymentOrderStatus["Failed"] = "FAILED";
    PaymentOrderStatus["Refunded"] = "REFUNDED";
    PaymentOrderStatus["PartRefunded"] = "PART_REFUNDED";
})(PaymentOrderStatus || (PaymentOrderStatus = {}));
export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Adyen"] = "ADYEN";
    PaymentProvider["AdyenClassic"] = "ADYEN_CLASSIC";
    PaymentProvider["Wallet"] = "WALLET";
})(PaymentProvider || (PaymentProvider = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "PENDING";
    PaymentStatus["Completed"] = "COMPLETED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Refunded"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var DealListSort;
(function (DealListSort) {
    DealListSort["Popularity"] = "popularity";
    DealListSort["Date"] = "date";
})(DealListSort || (DealListSort = {}));
export var DealsListType;
(function (DealsListType) {
    DealsListType["Company"] = "COMPANY";
    DealsListType["NearMe"] = "NEAR_ME";
    DealsListType["Earn"] = "EARN";
    DealsListType["Spend"] = "SPEND";
})(DealsListType || (DealsListType = {}));
export var DealCategoryType;
(function (DealCategoryType) {
    DealCategoryType["Earn"] = "EARN";
    DealCategoryType["Spend"] = "SPEND";
})(DealCategoryType || (DealCategoryType = {}));
export var DealPackageRegion;
(function (DealPackageRegion) {
    DealPackageRegion["En"] = "en";
    DealPackageRegion["Fr"] = "fr";
    DealPackageRegion["Au"] = "au";
    DealPackageRegion["Ire"] = "ire";
})(DealPackageRegion || (DealPackageRegion = {}));
export var DealPackagePaymentCountryCode;
(function (DealPackagePaymentCountryCode) {
    DealPackagePaymentCountryCode["Gb"] = "GB";
    DealPackagePaymentCountryCode["Fr"] = "FR";
    DealPackagePaymentCountryCode["Au"] = "AU";
    DealPackagePaymentCountryCode["Ie"] = "IE";
})(DealPackagePaymentCountryCode || (DealPackagePaymentCountryCode = {}));
export var FraudThresholdType;
(function (FraudThresholdType) {
    FraudThresholdType["BusinessOrderAmount"] = "BUSINESS_ORDER_AMOUNT";
    FraudThresholdType["UserOrderCount"] = "USER_ORDER_COUNT";
})(FraudThresholdType || (FraudThresholdType = {}));
export var CompanyNewsTileType;
(function (CompanyNewsTileType) {
    CompanyNewsTileType["Empty"] = "empty";
    CompanyNewsTileType["Image"] = "image";
    CompanyNewsTileType["Template"] = "template";
    CompanyNewsTileType["Video"] = "video";
})(CompanyNewsTileType || (CompanyNewsTileType = {}));
export var LayoutWidgetType;
(function (LayoutWidgetType) {
    LayoutWidgetType["Products"] = "products";
    LayoutWidgetType["Perks"] = "perks";
    LayoutWidgetType["CompanyNews"] = "companyNews";
})(LayoutWidgetType || (LayoutWidgetType = {}));
export var TenantAuditAction;
(function (TenantAuditAction) {
    TenantAuditAction["BulkResendWelcomeEmail"] = "BULK_RESEND_WELCOME_EMAIL";
    TenantAuditAction["Activated"] = "ACTIVATED";
    TenantAuditAction["Deactivated"] = "DEACTIVATED";
    TenantAuditAction["Onhold"] = "ONHOLD";
})(TenantAuditAction || (TenantAuditAction = {}));
export var UserAuditAction;
(function (UserAuditAction) {
    UserAuditAction["Activated"] = "ACTIVATED";
    UserAuditAction["Deactivated"] = "DEACTIVATED";
    UserAuditAction["EmailAddressChanged"] = "EMAIL_ADDRESS_CHANGED";
    UserAuditAction["RoleChanged"] = "ROLE_CHANGED";
})(UserAuditAction || (UserAuditAction = {}));
export var QuestionSelectionTypeEnum;
(function (QuestionSelectionTypeEnum) {
    QuestionSelectionTypeEnum["EvenDistribution"] = "evenDistribution";
    QuestionSelectionTypeEnum["FirstInFirstOut"] = "firstInFirstOut";
})(QuestionSelectionTypeEnum || (QuestionSelectionTypeEnum = {}));
export var InsRoomStatus;
(function (InsRoomStatus) {
    InsRoomStatus["Active"] = "ACTIVE";
    InsRoomStatus["Closed"] = "CLOSED";
})(InsRoomStatus || (InsRoomStatus = {}));
export var InsRoomResolutionTypes;
(function (InsRoomResolutionTypes) {
    InsRoomResolutionTypes["Resolved"] = "RESOLVED";
    InsRoomResolutionTypes["Declined"] = "DECLINED";
    InsRoomResolutionTypes["Notapplicable"] = "NOTAPPLICABLE";
    InsRoomResolutionTypes["Unabletoresolve"] = "UNABLETORESOLVE";
    InsRoomResolutionTypes["Other"] = "OTHER";
})(InsRoomResolutionTypes || (InsRoomResolutionTypes = {}));
export var InsRoomSubjectResourceTypes;
(function (InsRoomSubjectResourceTypes) {
    InsRoomSubjectResourceTypes["Comment"] = "COMMENT";
})(InsRoomSubjectResourceTypes || (InsRoomSubjectResourceTypes = {}));
export var InternalLogActionType;
(function (InternalLogActionType) {
    InternalLogActionType["ResendWelcomeEmail"] = "ResendWelcomeEmail";
    InternalLogActionType["DeactivateTenantUsers"] = "DeactivateTenantUsers";
})(InternalLogActionType || (InternalLogActionType = {}));
export var MerchantStatusEnum;
(function (MerchantStatusEnum) {
    MerchantStatusEnum["Active"] = "ACTIVE";
    MerchantStatusEnum["Inactive"] = "INACTIVE";
    MerchantStatusEnum["Suspended"] = "SUSPENDED";
    MerchantStatusEnum["Pending"] = "PENDING";
})(MerchantStatusEnum || (MerchantStatusEnum = {}));
export var TenantOnboardingStepStates;
(function (TenantOnboardingStepStates) {
    TenantOnboardingStepStates["Open"] = "OPEN";
    TenantOnboardingStepStates["Skipped"] = "SKIPPED";
    TenantOnboardingStepStates["Done"] = "DONE";
})(TenantOnboardingStepStates || (TenantOnboardingStepStates = {}));
export var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType["Amex"] = "amex";
    PaymentCardType["Mc"] = "mc";
    PaymentCardType["Visa"] = "visa";
})(PaymentCardType || (PaymentCardType = {}));
export var PermissionsRecognitionSharingOption;
(function (PermissionsRecognitionSharingOption) {
    PermissionsRecognitionSharingOption["AdminOnly"] = "ADMIN_ONLY";
    PermissionsRecognitionSharingOption["AdminAndManager"] = "ADMIN_AND_MANAGER";
    PermissionsRecognitionSharingOption["Everyone"] = "EVERYONE";
    PermissionsRecognitionSharingOption["Off"] = "OFF";
})(PermissionsRecognitionSharingOption || (PermissionsRecognitionSharingOption = {}));
export var PermissionsRecognitionCreatePollOption;
(function (PermissionsRecognitionCreatePollOption) {
    PermissionsRecognitionCreatePollOption["AdminOnly"] = "ADMIN_ONLY";
    PermissionsRecognitionCreatePollOption["AdminAndManager"] = "ADMIN_AND_MANAGER";
    PermissionsRecognitionCreatePollOption["Everyone"] = "EVERYONE";
    PermissionsRecognitionCreatePollOption["Off"] = "OFF";
})(PermissionsRecognitionCreatePollOption || (PermissionsRecognitionCreatePollOption = {}));
export var PermissionsRecognitionVisibilityOption;
(function (PermissionsRecognitionVisibilityOption) {
    PermissionsRecognitionVisibilityOption["On"] = "ON";
    PermissionsRecognitionVisibilityOption["Limited"] = "LIMITED";
    PermissionsRecognitionVisibilityOption["Off"] = "OFF";
})(PermissionsRecognitionVisibilityOption || (PermissionsRecognitionVisibilityOption = {}));
export var PermisionsMedicalTiers;
(function (PermisionsMedicalTiers) {
    PermisionsMedicalTiers["Tier1"] = "TIER1";
    PermisionsMedicalTiers["Tier2"] = "TIER2";
    PermisionsMedicalTiers["Tier3"] = "TIER3";
})(PermisionsMedicalTiers || (PermisionsMedicalTiers = {}));
export var ProductStockStatus;
(function (ProductStockStatus) {
    ProductStockStatus["Archived"] = "ARCHIVED";
    ProductStockStatus["Closed"] = "CLOSED";
    ProductStockStatus["Open"] = "OPEN";
    ProductStockStatus["Reserved"] = "RESERVED";
})(ProductStockStatus || (ProductStockStatus = {}));
export var StockUsage;
(function (StockUsage) {
    StockUsage["Multiple"] = "MULTIPLE";
    StockUsage["Single"] = "SINGLE";
})(StockUsage || (StockUsage = {}));
export var StockJobAction;
(function (StockJobAction) {
    StockJobAction["UpdateExpiry"] = "UPDATE_EXPIRY";
    StockJobAction["DeleteItems"] = "DELETE_ITEMS";
})(StockJobAction || (StockJobAction = {}));
export var StockJobStatus;
(function (StockJobStatus) {
    StockJobStatus["Done"] = "DONE";
    StockJobStatus["Failed"] = "FAILED";
    StockJobStatus["InProgress"] = "IN_PROGRESS";
})(StockJobStatus || (StockJobStatus = {}));
export var ScheduledTransferStatus;
(function (ScheduledTransferStatus) {
    ScheduledTransferStatus["NotActivated"] = "NOT_ACTIVATED";
    ScheduledTransferStatus["Cancelled"] = "CANCELLED";
    ScheduledTransferStatus["Pending"] = "PENDING";
    ScheduledTransferStatus["Failing"] = "FAILING";
    ScheduledTransferStatus["Failed"] = "FAILED";
})(ScheduledTransferStatus || (ScheduledTransferStatus = {}));
export var ReportingPeriodGranularity;
(function (ReportingPeriodGranularity) {
    ReportingPeriodGranularity["D"] = "D";
    ReportingPeriodGranularity["W"] = "W";
    ReportingPeriodGranularity["M"] = "M";
})(ReportingPeriodGranularity || (ReportingPeriodGranularity = {}));
export var ReportingSegmentOption;
(function (ReportingSegmentOption) {
    ReportingSegmentOption["Team"] = "TEAM";
    ReportingSegmentOption["PerkUuid"] = "PERK_UUID";
    ReportingSegmentOption["PerkCategory"] = "PERK_CATEGORY";
    ReportingSegmentOption["PerkType"] = "PERK_TYPE";
})(ReportingSegmentOption || (ReportingSegmentOption = {}));
export var ReportingFilterOption;
(function (ReportingFilterOption) {
    ReportingFilterOption["Team"] = "TEAM";
    ReportingFilterOption["PerkUuid"] = "PERK_UUID";
    ReportingFilterOption["PerkCategory"] = "PERK_CATEGORY";
    ReportingFilterOption["PerkType"] = "PERK_TYPE";
})(ReportingFilterOption || (ReportingFilterOption = {}));
export var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["Public"] = "PUBLIC";
    CacheControlScope["Private"] = "PRIVATE";
})(CacheControlScope || (CacheControlScope = {}));
export var PaymentWalletType;
(function (PaymentWalletType) {
    PaymentWalletType["Personal"] = "personal";
    PaymentWalletType["Rewards"] = "rewards";
})(PaymentWalletType || (PaymentWalletType = {}));
